import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface ISummaryTileProps {
  value: string;
  label: string;
  delta: ReactNode;
  className?: string;
}

/**
 * Small white tile (value + label + delta) used by ThroughputSummaryCard and
 * WipSummaryCard. NOT a replacement for `KpiCard` — that has DORA-level
 * borders and larger spacing; this one is tighter for the right-rail layout.
 */
export function SummaryTile({ value, label, delta, className }: Readonly<ISummaryTileProps>) {
  return (
    <div className={cn('rounded-lg border border-border bg-background p-2 text-center', className)}>
      <div className="text-lg font-bold text-foreground">{value}</div>
      <div className="mt-0.5 text-xs text-muted-foreground">{label}</div>
      <div className="mt-1">{delta}</div>
    </div>
  );
}
